import { GET_PT_TEAM_MANAGEMENT } from '_revamp/redux/action/admin/team_management';

const initialState = {
  list: [],
  detail: [],
};

const auth = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_PT_TEAM_MANAGEMENT: {
      if (payload.detail) {
        return {
          ...state,
          detail: payload,
        };
      }
      return {
        ...state,
        list: payload,
      };
    }

    default:
      return state;
  }
};

export default auth;
